// Get main elements
function getElements() {
  return {
    variantSelects: document.querySelector('variant-selects[id*="variant-selects-template"]'),
    jurassicSection: document.getElementById('_jurassic_certificate_section_')
  };
}

// Get nested elements inside the Jurassic section
function getJurassicElements(jurassicSection) {
  return {
    imgElement: document.querySelector('#_jurassic_certificate_section_image_'),
    spanElement: document.querySelector('#_jurassic_certificate_section_label_')
  };
}

function clearCertificates(jurassicSection) {
  const wrappers = jurassicSection.querySelectorAll(".sertificate_item_wrapper");
  wrappers.forEach((el) => el.remove());
}

function renderCertificates(selectedVariant, jurassicSection) {
    clearCertificates(jurassicSection);

    const productData = jurassicSection?.getAttribute('data-product');

    let product = null;

    try {
      product = JSON.parse(productData);
    } catch (error) {
      console.error('Error parsing data-product:', error);
      product = null;
    }

    if (!selectedVariant || !selectedVariant?.certificate || !selectedVariant?.certificate?.length) {

      if (!product || !product?.certificate || !product?.certificate?.length) return;

      product.certificate.forEach((cert) => {
      const wrapper = document.createElement("div");
      wrapper.className = "sertificate_item_wrapper";

      const img = document.createElement("img");
      img.src = cert.badge_image;
      img.alt = cert.display_name || cert.type;
      img.width = 45;
      img.height = 28;
      img.className = "certificate-image";

      const span = document.createElement("span");
      span.className = "certificate-label";
      span.textContent = cert.display_name || cert.type;

      wrapper.appendChild(img);
      wrapper.appendChild(span);
      jurassicSection.appendChild(wrapper);
    });

      return;
    }
    selectedVariant.certificate.forEach((cert) => {
      const wrapper = document.createElement("div");
      wrapper.className = "sertificate_item_wrapper";

      const img = document.createElement("img");
      img.src = cert.badge_image;
      img.alt = cert.display_name || cert.type;
      img.width = 45;
      img.height = 28;
      img.className = "certificate-image";

      const span = document.createElement("span");
      span.className = "certificate-label";
      span.textContent = cert.display_name || cert.type;

      wrapper.appendChild(img);
      wrapper.appendChild(span);
      jurassicSection.appendChild(wrapper);
    });
  }

// Parse the data-variants attribute safely
function parseVariantsData(variantsData) {
  try {
    return JSON.parse(variantsData);
  } catch (error) {
    console.error('Error parsing data-variants:', error);
    return null;
  }
}

// Add img and label
function addImgAndLabel(selectedVariant, jurassicSection) {

   renderCertificates(selectedVariant, jurassicSection);

}

// Update visibility based on the variant
function updateJurassicVisibility(selectedVariant, jurassicSection) {
  if (!jurassicSection) return;

  if (selectedVariant && selectedVariant.certificate) {
    addImgAndLabel(selectedVariant, jurassicSection);
    setupMutationObserver()
  } else {
    clearCertificates(jurassicSection);
    setupMutationObserver()
  }
}

// Handle variant selection
function handleVariantSelection(variantSelects, jurassicSection) {
  const checkedInput = variantSelects?.querySelector('input[type="radio"]:checked');
  const variantsData = jurassicSection?.getAttribute('data-variants');
  const variants = parseVariantsData(variantsData);

  let selectedVariant = null;

  if (checkedInput && variants) {
    selectedVariant = variants.find(variant => variant.title === checkedInput.value);
  }

  // fallback to the first variant if none selected
  if (!selectedVariant && variants?.length) {
    selectedVariant = variants[0];
  }

  updateJurassicVisibility(selectedVariant, jurassicSection);
}

// Process current state (initial or on DOM changes)
function processCurrentState() {
  const { variantSelects, jurassicSection } = getElements();

  if (variantSelects || jurassicSection) {
    handleVariantSelection(variantSelects, jurassicSection);
  } else {
    console.log('Neither variant-selects nor Jurassic Certificate Section found');
  }
}

// Setup MutationObserver for radio input checked changes
function setupMutationObserver() {
  const { variantSelects } = getElements();

  const targetNode = variantSelects;

  if (!targetNode) return;

    const observer = new MutationObserver((mut) => {
        processCurrentState();
    });
    observer.observe(targetNode, {
        childList: true,
        subtree: true,
        attributes: true,
        // attributeFilter: ['checked']
    });
}

// Main function to track variant changes
function trackVariantChanges() {
  // Initial processing
  processCurrentState();

  // Setup observer for changes in checked inputs
  setupMutationObserver();
}

document.addEventListener('DOMContentLoaded', trackVariantChanges);

